<template>
	<div v-if="open" class="flow-modalbox-container">
		<div class="flow-modalbox-overlay" />
		<div class="flow-modalbox" :style="modalStyle">
			<div v-if="$slots['header']" class="flow-modalbox-header">
				<slot name="header" />
			</div>
			<div class="flow-modalbox-body">
				<slot />
			</div>
			<div v-if="$slots['footer']" class="flow-modalbox-footer">
				<slot name="footer" />
			</div>
		</div>
	</div>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
	name: "ModalBox",
	props: {
		open: {
			type: Boolean,
			default: true
		},
		width: {
			type: [Number, String],
			default: 500
		},
		background: {
			type: String,
			default: "var(--dashboard-element)"
		},
		/**
		 * How content overflow should work? <br/>
		 * 'hidden' | 'auto' | 'scroll' | 'visible'
		 */
		overflow: {
			type: String,
			default: "hidden"
		}
	},
	computed: {
		computedWidth() {
			if (typeof this.width === "number") {
				return `${this.width}px`;
			}
			return this.width;
		},
		modalStyle() {
			return {
				width: this.computedWidth,
				backgroundColor: this.background,
				overflow: this.overflow
			};
		}
	}
});
</script>
<style lang="scss">
div.flow-modalbox-container {
	display: flex;
	align-items: center;
	justify-content: center;
	position: fixed;
	top: 0px;
	left: 0px;
	bottom: 0px;
	right: 0px;
	z-index: 105;

	div.flow-modalbox-overlay {
		content: "";
		position: fixed;
		top: 0px;
		left: 0px;
		width: 100%;
		height: 100%;
		background-color: var(--slideout-blackout);
		transition: background 0.3s linear;
		z-index: 101;
	}

	div.flow-modalbox {
		z-index: 102;
		background-color: var(--dashboard-element);
		border-radius: 8px;
		height: fit-content;
		max-height: 80%;
		display: flex;
		flex-direction: column;
		overflow: hidden;
		justify-content: space-between;

		div.flow-modalbox-footer {
			background-color: var(--dashboard-element-light);
			// padding: 20px;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			border-bottom-left-radius: 8px;
			border-bottom-right-radius: 8px;
		}

		div.flow-modalbox-body {
			overflow: auto;
			flex: 1;
		}
	}

	div.flow-form-field-wrapper {
		margin-bottom: 0px;
	}
}
</style>
